import { z } from 'zod';

export const totpCodeSchema = z.object({
  code: z
    .string()
    .trim()
    .regex(/^[0-9]{6}$/u, 'code_invalid'),
});

export type TotpCodeInput = z.infer<typeof totpCodeSchema>;

/**
 * Recovery code schema. Backend codes are typically 8–10 alphanumeric chars,
 * sometimes with hyphens. We do not enforce a strict length here — only that
 * a non-empty string of plausibly-recovery-code shape was entered.
 */
export const recoveryCodeSchema = z.object({
  recovery_code: z
    .string()
    .trim()
    .min(6, 'recovery_code_invalid')
    .max(64, 'recovery_code_invalid')
    .regex(/^[A-Za-z0-9-]+$/u, 'recovery_code_invalid'),
});

export type RecoveryCodeInput = z.infer<typeof recoveryCodeSchema>;
